<!-- Sandboxed space (Partner Portal): a frame around the whole screen and a bar with the way back to ONE -->
@if (config.sandbox; as sandbox) {
  <div
    class="sandbox-frame"
    aria-hidden="true"
  ></div>
  <div
    class="sandbox-bar"
    role="region"
    [attr.aria-label]="sandbox.label"
  >
    <span class="sandbox-bar__label">{{ sandbox.label }}</span>
    @if (sandboxReturn; as target) {
      <button
        type="button"
        class="sandbox-bar__return"
        (click)="returnFromSandbox()"
      >
        <kendo-svgicon
          [icon]="arrowLeftIcon"
          aria-hidden="true"
        ></kendo-svgicon>
        {{ target.label }}
      </button>
    }
  </div>
}
<kendo-drawer-container
  class="k-body"
  [class.k-body--sandboxed]="config.sandbox"
>
  <kendo-drawer
    class="kendo-drawer-content"
    #drawer
    [items]="Items()"
    mode="push"
    [mini]="true"
    [expanded]="drawerExpanded()"
    (select)="onSelect($event)"
    [autoCollapse]="false"
    [isItemExpanded]="isItemExpanded"
  >
    <!-- Sidebar Header Template - Logo and Org Selector -->
    <ng-template kendoDrawerHeaderTemplate>
      <div class="sidebar-header">
        @if (drawerExpanded()) {
          <img
            [src]="whitelabel.logo()"
            alt="logo"
            class="sidebar-logo"
          />
        } @else {
          <img
            [src]="whitelabel.logo()"
            alt="logo"
            class="sidebar-logo-mini"
          />
        }
      </div>

      <!-- Organization Selector - Only visible when expanded -->
      @if (drawerExpanded() && config.showOrgPicker !== false) {
        <div class="sidebar-org-selector">
          <app-org-picker
            [currentOrg]="currentOrg()"
            (orgSelected)="onOrgDropdownChanged($event)"
          ></app-org-picker>
        </div>
      }
    </ng-template>

    <!-- Sidebar Footer Template - User Controls -->
    <ng-template kendoDrawerFooterTemplate>
      <div
        class="kendo-drawer-footer"
        [class.footer-expanded]="drawerExpanded()"
        [class.footer-collapsed]="!drawerExpanded()"
      >
        <!-- VIP Support Button (Beta Orgs Only) -->
        @if (config.footer.showVipSupport && showVipSupport()) {
          <div
            class="sidebar-footer-item"
            (click)="handlePopup('vipSupport')"
          >
            <span class="footer-icon">
              <kendo-svgicon [icon]="infoCircleIcon"></kendo-svgicon>
            </span>
            @if (drawerExpanded()) {
              <span class="footer-text">
                VIP Support
              </span>
            }
          </div>
        }

        <!-- Info/Resources Menu -->
        @if (config.footer.showResources && config.resourceLinks.length > 0) {
          @if (drawerExpanded()) {
            <kendo-dropdownbutton
              class="sidebar-footer-item"
              [svgIcon]="menuIcon"
              [data]="config.resourceLinks"
              textField="text"
              fillMode="flat"
              (itemClick)="onItemClick($event)"
            >
              <span class="footer-text">Resources</span>
            </kendo-dropdownbutton>
          } @else {
            <kendo-dropdownbutton
              class="sidebar-footer-item"
              [svgIcon]="menuIcon"
              [data]="config.resourceLinks"
              textField="text"
              fillMode="flat"
              (itemClick)="onItemClick($event)"
            ></kendo-dropdownbutton>
          }
        }

        <!-- Notifications -->
        @if (config.footer.showNotifications) {
          <div
            class="sidebar-footer-item sidebar-notification-badge"
            (click)="handlePopup('notifications')"
          >
            <span class="footer-icon">
              <kendo-svgicon [icon]="bellIcon"></kendo-svgicon>
            </span>
            @if (this.notifications().length > 0) {
              <span class="notification-count">{{ this.notifications().length }}</span>
            }
            @if (drawerExpanded()) {
              <span class="footer-text">Notifications</span>
            }
          </div>
        }

        <div class="sidebar-footer-divider"></div>

        <!-- Settings -->
        @if (config.footer.showSettings && config.settingsRoute) {
          <div
            class="sidebar-footer-item"
            [class.sidebar-footer-item-active]="settingsActive()"
            (click)="navigateToSettings()"
          >
            <span class="footer-icon">
              <kendo-svgicon [icon]="gearsIcon"></kendo-svgicon>
            </span>
            @if (drawerExpanded()) {
              <span class="footer-text">Settings</span>
            }
          </div>
        }

        <!-- User Avatar Dropdown -->
        @if (config.footer.showUserAvatar) {
          <kendo-dropdownbutton
            class="sidebar-footer-item user-avatar-dropdown"
            fillMode="flat"
            [data]="data"
            (itemClick)="onUserProfileClick($event)"
          >
            <span class="user-avatar-content">
              @if (avatarText !== null) {
                <span class="sidebar-user-avatar">{{ avatarText }}</span>
              } @else {
                <span class="footer-icon">
                  <kendo-svgicon [icon]="userIcon"></kendo-svgicon>
                </span>
              }
              @if (drawerExpanded()) {
                <span class="footer-text">Account</span>
              }
            </span>
          </kendo-dropdownbutton>
        }
      </div>

      <!-- Floating Collapse/Expand Toggle - Glass effect -->
      <div
        class="sidebar-collapse-toggle"
        [class.sidebar-collapse-toggle-mini]="!drawerExpanded()"
      >
        <button
          kendoButton
          fillMode="flat"
          (click)="toggleDrawer()"
        >
          @if (drawerExpanded()) {
            <kendo-svgicon [icon]="chevronDoubleLeftIcon"></kendo-svgicon>
          } @else {
            <kendo-svgicon [icon]="chevronDoubleRightIcon"></kendo-svgicon>
          }
        </button>
      </div>
    </ng-template>
  </kendo-drawer>

  <!-- Main Content Canvas -->
  <kendo-drawer-content class="canvas-wrapper">
    <div class="canvas-content">
      <div class="canvas-content-inner">
        <router-outlet #anchor></router-outlet>
      </div>
    </div>
  </kendo-drawer-content>
</kendo-drawer-container>

<!-- CASI: "Ask CASI" tab on the right edge opens the slideout (internal Cyflare admins, prod) -->
@if (showCasi) {
  <app-casi-side-tab (open)="toggleCasi()" />
}

<!-- CASI slideout: loaded on first open, stays open across navigation -->
@if (showCasi && casi.panelOpen()) {
  @defer (on immediate) {
    <app-casi-chat-panel [appOrg]="currentOrg()" />
  }
}
